import AlimentationFilter from './AlimentationFilter';
export default AlimentationFilter;
